import { createApp } from "vue";
import ImageZoom from "../pages/ImageZoom.vue";
import { ready } from "../utils/listeners";

window.initialiseImageZoom = () => {
  const node = document.querySelector("#image-zoom-app");
  if (!node) return;

  const props = JSON.parse(node.dataset.props);
  const app = createApp(ImageZoom, props);
  app.mount(node);

  const observer = new MutationObserver((mutationsList, obs) => {
    // If the node is not present in the document, unmount the Vue app. This could happen in the case of switching variants on the PDP.
    if (!document.contains(node)) {
      app.unmount();
      obs.disconnect();
    }
  });

  observer.observe(document, { childList: true, subtree: true });
};

ready(() => {
  window.initialiseImageZoom();
});
